import { Button } from "@mui/material";
import React from "react";

import { ReactComponent as AnnotationHelpIcon } from "assets/edit-mode-annotation-help.svg";

import styles from "./SmartVectorsHelpButton.module.scss";

type Props = {
  onClick?: () => void;
};

const SmartVectorsHelpButton = ({ onClick }: Props) => {
  return (
    <Button
      type="button"
      className={styles.helpBtn}
      disableElevation
      onClick={onClick ?? (() => {})}
    >
      <AnnotationHelpIcon className={styles.helpIcon} aria-hidden />
      Help
    </Button>
  );
};

export default SmartVectorsHelpButton;
